
export interface IVisitConsentDentalExtractionRequest {
    authorizationResponseId: number;
    authorizationLimit: string;
}

export class VisitConsentDentalExtractionRequest implements IVisitConsentDentalExtractionRequest {
    authorizationResponseId: number;
    authorizationLimit: string;

    constructor(params: IVisitConsentDentalExtractionRequest) {
        this.authorizationResponseId = _.defaultTo(params.authorizationResponseId, 0);
        this.authorizationLimit = _.defaultTo(params.authorizationLimit, '');
    }
}
